import * as React from 'react';
import { Box, Button, MenuItem, Paper, Select, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Modal } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import { useEffect, useState } from "react";
import { format } from 'date-fns';
import { useNavigate, useLocation } from "react-router-dom";
import Pool from "./../UserPool";
import axios from "axios";
import { configure } from '../../config';
const config = {
    headers: {
        "Access-Control-Allow-Origin": "*",
        'Content-Type': 'application/json',
        "Access-Control-Allow-Methods": "GET,PUT,POST,OPTIONS,ANY",
        "Access-Control-Allow-Headers": "Origin, Content-Type, Accept, Authorization, X-Requested-With, privatekey"
    }
};


const DashboardCustomer = () => {
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [desc, setDesc] = useState("");
    const [customer, setCustomer] = useState("");
    const [species, setSpecies] = useState("");
    const [sampleName, setSampleName] = useState("");
    const [sDate, setSDate] = useState("");
    const [eDate, setEDate] = useState("");
    const [status, setStatus] = useState(0);
    const [filterData, setFilterData] = useState([]);
    const [tempData, setTempData] = useState([]);

    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    var user = JSON.parse(sessionStorage.getItem("userProfile"));
    var storedValue = sessionStorage.getItem('clickedInstrument')
    const typeData = JSON.stringify({ type: 'ViewAll', instrument: storedValue, company_name: user.nickname });
    var user = JSON.parse(sessionStorage.getItem("userProfile"));
    const { state } = useLocation();
    const navigate = useNavigate();
    var idToken = JSON.parse(sessionStorage.getItem("accessToken"));

    var filterObject = {
        desc: "",
        customer: "",
        species: "",
        sampleName: "",
        sDate: "",
        eDate: "",
        status: 0,
    }

    if (user === null) {
        const userLogin = Pool.getCurrentUser();
        if (userLogin) {
            userLogin.signOut();
        }
        return navigate('/login');
    }
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    useEffect(() => {
        var response = JSON.parse(sessionStorage.getItem("experimentData"));
        if (state) {
            if (validateFilter(filterObject)) {
                experimentData();
            } else {
                var filterData = JSON.parse(sessionStorage.getItem("filterItem"));
                var originalData = JSON.parse(sessionStorage.getItem("originalData"));
                setData(originalData);
                setFilterData(filterData);
            }
        }
        else {
            experimentData();
        }
    }, []);

    const experimentData = async () => {
        config.headers.Authorization = "Bearer " + idToken.jwtToken;
        const typeData = JSON.stringify({
            type: 'ViewAll',
            instrument: storedValue,
            company_name: user.nickname
        })
        const response = await fetch(`${configure.backendUrl}/dynamodb`, {
            method: 'POST',
            body: typeData,
            headers: new Headers({ 'Authorization': 'Bearer ' + idToken.jwtToken })
        });
        const responseExp = await response.json();
        if (responseExp && response.status === 200) {
            if (user.nickname === "Bio-Rad" || user.nickname === "BioRad" || user.nickname === "Biorad" || user.nickname === "BIO-RAD" || user.nickname === "BIORAD") {
                sessionStorage.setItem("experimentData", JSON.stringify(responseExp.filter(m => m.experiment_status !== "Saved")));
                var filterdata = responseExp.filter(m => m.experiment_status !== "Saved")
                setData(filterdata);
                setFilterData(filterdata);
            }
            else {
                sessionStorage.setItem("experimentData", JSON.stringify(responseExp));
                setData(responseExp);
                setFilterData(responseExp);
            }
        }
    }


    const validateFilter = (filData) => {
        return filData && filData.customer === "" && filData.desc === "" && filData.species === ""
            && filData.sDate === "" && filData.eDate === "" && filData.sampleName === "" &&
            filData.status === 0;
    }
    const dateFilter = (filteredData) => {
        if (sDate !== "" && eDate !== "") {
            // let datas = format(new Date(data[0].experiment_date),  "yyyy-MM-dd");
            if (sDate === eDate) {
                filteredData = data.filter(
                    (obj) => {
                        return new Date(obj.experiment_date) >= new Date(sDate) && new Date(obj.experiment_date) <= new Date(eDate)
                    }
                )
            }
            else {
                filteredData = data.filter(
                    (obj) => {
                        return new Date(obj.experiment_date) >= new Date(sDate) &&
                            new Date(obj.experiment_date) <= new Date(eDate)
                    }
                )
            }

            setFilterData(filteredData)
        }
        else if (sDate !== "") {
            filteredData = data.filter(
                (obj) => {
                    return new Date(obj.experiment_date) >= new Date(sDate)
                }
            )
            setFilterData(filteredData)
        }
        else if (eDate !== "") {
            filteredData = data.filter(
                (obj) => {
                    return new Date(obj.experiment_date) <= new Date(eDate)
                }
            )
            setFilterData(filteredData)
        }
        return filteredData;
    }
    const searchFilter = async () => {
        var filteredData = []
        data.forEach(element => {
            element.experiment_date = format(new Date(element.experiment_date), "yyyy-MM-dd")
        });
        setFilterData([]);
        setFilterData(data)
        filteredData = await dateFilter(filteredData);
        if (desc !== "" && species !== "" && sampleName !== "" && status !== 0) {
            var statusName = ""
            if (status === 1) {
                statusName = "New"
            }
            else if (status === 2) {
                statusName = "Saved"
            }
            else if (status === 3) {
                statusName = "Submitted"
            }
            else if (status === 4) {
                statusName = "Acknowledged"
            }
            else if (status === 5) {
                statusName = "Responded"
            }
            else if (status === 6) {
                statusName = "Closed"
            }
            if (sDate !== "" || eDate !== "") {
                filteredData = await dateFilter(filteredData);
                filteredData = filteredData.filter(
                    m => m.description.toLowerCase().includes(desc.toLowerCase()) && m.species.toLowerCase().includes(species.toLowerCase())
                        && m.sample_name.toLowerCase().includes(sampleName.toLowerCase()) && m.experiment_status.includes(statusName)
                );
            }
            else {
                filteredData = data.filter(
                    m => m.description.toLowerCase().includes(desc.toLowerCase()) && m.species.toLowerCase().includes(species.toLowerCase())
                        && m.sample_name.toLowerCase().includes(sampleName.toLowerCase()) && m.experiment_status.includes(statusName)
                )
            }
            setFilterData(filteredData)
        }
        else if (species !== "" && sampleName !== "" && status !== 0) {
            var statusName = ""
            if (status === 1) {
                statusName = "New"
            }
            else if (status === 2) {
                statusName = "Saved"
            }
            else if (status === 3) {
                statusName = "Submitted"
            }
            else if (status === 4) {
                statusName = "Acknowledged"
            }
            else if (status === 5) {
                statusName = "Responded"
            }
            else if (status === 6) {
                statusName = "Closed"
            }
            if (sDate !== "" || eDate !== "") {
                filteredData = await dateFilter(filteredData);
                filteredData = filteredData.filter(m => m.species.toLowerCase().includes(species.toLowerCase())
                    && m.sample_name.toLowerCase().includes(sampleName.toLowerCase()) && m.experiment_status.includes(statusName))
            }
            else {
                filteredData = data.filter(m => m.species.toLowerCase().includes(species.toLowerCase())
                    && m.sample_name.toLowerCase().includes(sampleName.toLowerCase()) && m.experiment_status.includes(statusName))
            }
            setFilterData(filteredData)
        }
        else if (desc !== "" && sampleName !== "" && status !== 0) {
            var statusName = ""
            if (status === 1) {
                statusName = "New"
            }
            else if (status === 2) {
                statusName = "Saved"
            }
            else if (status === 3) {
                statusName = "Submitted"
            }
            else if (status === 4) {
                statusName = "Acknowledged"
            }
            else if (status === 5) {
                statusName = "Responded"
            }
            else if (status === 6) {
                statusName = "Closed"
            }
            if (sDate !== "" || eDate !== "") {
                filteredData = await dateFilter(filteredData);
                filteredData = filteredData.filter(m => m.description.toLowerCase().includes(desc.toLowerCase()) && m.sample_name.toLowerCase().includes(sampleName.toLowerCase()) && m.experiment_status.includes(statusName))
            }
            else {
                filteredData = data.filter(m => m.description.toLowerCase().includes(desc.toLowerCase()) && m.sample_name.toLowerCase().includes(sampleName.toLowerCase()) && m.experiment_status.includes(statusName))
            }

            setFilterData(filteredData)
        }
        else if (desc !== "" && species !== "" && status !== 0) {
            var statusName = ""
            if (status === 1) {
                statusName = "New"
            }
            else if (status === 2) {
                statusName = "Saved"
            }
            else if (status === 3) {
                statusName = "Submitted"
            }
            else if (status === 4) {
                statusName = "Acknowledged"
            }
            else if (status === 5) {
                statusName = "Responded"
            }
            else if (status === 6) {
                statusName = "Closed"
            }
            if (sDate !== "" || eDate !== "") {
                filteredData = await dateFilter(filteredData);
                filteredData = filteredData.filter(m => m.description.toLowerCase().includes(desc.toLowerCase()) && m.species.toLowerCase().includes(species.toLowerCase())
                    && m.experiment_status.includes(statusName))
            }
            else {
                filteredData = data.filter(m => m.description.toLowerCase().includes(desc.toLowerCase()) && m.species.toLowerCase().includes(species.toLowerCase())
                    && m.experiment_status.includes(statusName))
            }
            setFilterData(filteredData)
        }
        else if (desc !== "" && species !== "") {
            if (sDate !== "" || eDate !== "") {
                filteredData = await dateFilter(filteredData);
                filteredData = filteredData.filter(m => m.description.toLowerCase().includes(desc.toLowerCase()) && m.species.toLowerCase().includes(species.toLowerCase()))
            }
            else {
                filteredData = data.filter(m => m.description.toLowerCase().includes(desc.toLowerCase()) && m.species.toLowerCase().includes(species.toLowerCase()))
            }

            setFilterData(filteredData)
        }
        else if (desc !== "" && sampleName !== "") {
            if (sDate !== "" || eDate !== "") {
                filteredData = await dateFilter(filteredData);
                filteredData = filteredData.filter(m => m.description.toLowerCase().includes(desc.toLowerCase()) && m.sample_name.toLowerCase().includes(sampleName.toLowerCase()))
            }
            else {
                filteredData = data.filter(m => m.description.toLowerCase().includes(desc.toLowerCase()) && m.sample_name.toLowerCase().includes(sampleName.toLowerCase()))
            }

            setFilterData(filteredData)
        }
        else if (species !== "" && sampleName !== "") {
            if (sDate !== "" || eDate !== "") {
                filteredData = await dateFilter(filteredData);
                filteredData = filteredData.filter(m => m.species.toLowerCase().includes(species.toLowerCase()) && m.sample_name.toLowerCase().includes(sampleName.toLowerCase()))
            }
            else {
                filteredData = data.filter(m => m.species.toLowerCase().includes(species.toLowerCase()) && m.sample_name.toLowerCase().includes(sampleName.toLowerCase()))
            }

            setFilterData(filteredData)
        }
        else if (desc !== "" && status !== 0) {
            var statusName = ""
            if (status === 1) {
                statusName = "New"
            }
            else if (status === 2) {
                statusName = "Saved"
            }
            else if (status === 3) {
                statusName = "Submitted"
            }
            else if (status === 4) {
                statusName = "Acknowledged"
            }
            else if (status === 5) {
                statusName = "Responded"
            }
            else if (status === 6) {
                statusName = "Closed"
            }
            if (sDate !== "" || eDate !== "") {
                filteredData = await dateFilter(filteredData);
                filteredData = filteredData.filter(m => m.description.toLowerCase().includes(desc.toLowerCase()) && m.experiment_status.includes(statusName))
            }
            else {
                filteredData = data.filter(m => m.description.toLowerCase().includes(desc.toLowerCase()) && m.experiment_status.includes(statusName))
            }
            setFilterData(filteredData);
        }
        else if (species !== "" && status !== 0) {
            var statusName = ""
            if (status === 1) {
                statusName = "New"
            }
            else if (status === 2) {
                statusName = "Saved"
            }
            else if (status === 3) {
                statusName = "Submitted"
            }
            else if (status === 4) {
                statusName = "Acknowledged"
            }
            else if (status === 5) {
                statusName = "Responded"
            }
            else if (status === 6) {
                statusName = "Closed"
            }
            if (sDate !== "" || eDate !== "") {
                filteredData = await dateFilter(filteredData);
                filteredData = filteredData.filter(m => m.species.toLowerCase().includes(species.toLowerCase()) && m.experiment_status.includes(statusName))
            }
            else {
                filteredData = data.filter(m => m.species.toLowerCase().includes(species.toLowerCase()) && m.experiment_status.includes(statusName))
            }
            setFilterData(filteredData)
        }
        else if (sampleName !== "" && status !== 0) {
            var statusName = ""
            if (status === 1) {
                statusName = "New"
            }
            else if (status === 2) {
                statusName = "Saved"
            }
            else if (status === 3) {
                statusName = "Submitted"
            }
            else if (status === 4) {
                statusName = "Acknowledged"
            }
            else if (status === 5) {
                statusName = "Responded"
            }
            else if (status === 6) {
                statusName = "Closed"
            }
            if (sDate !== "" || eDate !== "") {
                filteredData = await dateFilter(filteredData);
                filteredData = filteredData.filter(m => m.sample_name.toLowerCase().includes(sampleName.toLowerCase()) && m.experiment_status.includes(statusName))
            }
            else {
                filteredData = data.filter(m => m.sample_name.toLowerCase().includes(sampleName.toLowerCase()) && m.experiment_status.includes(statusName))
            }
            setFilterData(filteredData)
        }
        else if (desc !== "") {
            if (sDate !== "" || eDate !== "") {
                filteredData = await dateFilter(filteredData);
                filteredData = filteredData.filter(m => m.description.toLowerCase().includes(desc.toLowerCase()))
            }
            else {
                filteredData = data.filter(m => m.description.toLowerCase().includes(desc.toLowerCase()))
            }
            setFilterData(filteredData)
        }
        else if (species !== "") {
            if (sDate !== "" || eDate !== "") {
                filteredData = await dateFilter(filteredData);
                filteredData = filteredData.filter(m => m.species.toLowerCase().includes(species.toLowerCase()))
            }
            else {
                filteredData = data.filter(m => m.species.toLowerCase().includes(species.toLowerCase()))
            }
            setFilterData(filteredData)
        }
        else if (sampleName !== "") {
            if (sDate !== "" || eDate !== "") {
                filteredData = await dateFilter(filteredData);
                filteredData = filteredData.filter(m => m.sample_name.toLowerCase().includes(sampleName.toLowerCase()))
            }
            else {
                filteredData = data.filter(m => m.sample_name.toLowerCase().includes(sampleName.toLowerCase()))
            }
            setFilterData(filteredData)
        }
        else if (status !== 0) {
            var statusName = ""
            if (status === 1) {
                statusName = "New"
            }
            else if (status === 2) {
                statusName = "Saved"
            }
            else if (status === 3) {
                statusName = "Submitted"
            }
            else if (status === 4) {
                statusName = "Acknowledged"
            }
            else if (status === 5) {
                statusName = "Responded"
            }
            else if (status === 6) {
                statusName = "Closed"
            }
            if (sDate !== "" || eDate !== "") {
                filteredData = await dateFilter(filteredData);
                filteredData = filteredData.filter(m => m.experiment_status.includes(statusName));
            }
            else {
                filteredData = data.filter(m => m.experiment_status.includes(statusName));
            }
            setFilterData(filteredData);
        }

        if (customer !== "") {
            if (sDate !== "" && eDate !== "") {
                filteredData = await dateFilter(filteredData);
                filteredData = filteredData.filter(m => m.company_name.toLowerCase().includes(customer.toLowerCase()))
            }
            else if (sDate !== "") {
                filteredData = await dateFilter(filteredData);
                filteredData = filteredData.filter(m => m.company_name.toLowerCase().includes(customer.toLowerCase()))
            }
            else if (eDate !== "") {
                filteredData = await dateFilter(filteredData);
                filteredData = filteredData.filter(m => m.company_name.toLowerCase().includes(customer.toLowerCase()))
            }
            else {
                filteredData = filterData.filter(m => m.company_name.toLowerCase().includes(customer.toLowerCase()))
            }
            setFilterData(filteredData)
        }
        sessionStorage.setItem("filterItem", JSON.stringify(filteredData))
        sessionStorage.setItem("originalData", JSON.stringify(data));
    };
    const handleClearFilter = () => {
        setDesc("");
        setSpecies("");
        setSampleName("");
        setCustomer("");
        setSDate("");
        setEDate("");
        setStatus(0);

        setFilterData(data);
        setPage(0);
        setRowsPerPage(10);

        sessionStorage.removeItem("filterAttribute");
        sessionStorage.removeItem("filterItem");
        sessionStorage.removeItem("originalData");

    };
    return (
        <div>
            <Box sx={{ display: 'flex', flexDirection: 'column', marginTop: -1.5 }}>
                <Box sx={{ display: 'flex' }}>
                    <Box p={1} sx={{ display: 'flex', alignItems: 'center' }}>
                        {/* <Typography fontWeight={500} fontSize={14} color="text.secondary" style={{ marginRight: 5 }}>
                        Description
                          </Typography> */}
                        <TextField size="small" placeholder='Description' onKeyDown={searchFilter} value={desc} onChange={(event) => setDesc(event.target.value)} inputProps={{ style: { height: "12px", fontSize: "14px", width: "21.6vw", padding: "10px 14px 8px 14px" } }} />
                    </Box>
                    <Box p={1} sx={{ display: 'flex', alignItems: 'center' }}>
                        {/* <Typography fontWeight={500} fontSize={14} color="text.secondary" style={{ marginRight: 5 }}> Species</Typography> */}
                        <TextField size="small" placeholder='Species' onKeyDown={searchFilter} value={species} onChange={(event) => setSpecies(event.target.value)} sx={{ width: '82%' }} inputProps={{ style: { height: "12px", fontSize: "14px", padding: "10px 14px 8px 14px" } }} />
                    </Box>
                    <Box p={1} sx={{ display: 'flex', alignItems: 'center' }}>
                        {/* <Typography fontWeight={500} fontSize={14} color="text.secondary" style={{ marginRight: 5 }}> Sample Name</Typography> */}
                        <TextField size="small" placeholder='Sample Name' onKeyDown={searchFilter} value={sampleName} onChange={(event) => setSampleName(event.target.value)} sx={{ width: '96%' }} style={{ marginLeft: -31 }} inputProps={{ style: { height: "12px", fontSize: "14px", padding: "10px 14px 8px 14px" } }} />
                    </Box>

                </Box>
                <Box sx={{ display: 'flex', marginTop: -1.5 }}>
                    {(user.nickname === "Bio-Rad" || user.nickname === "BioRad" || user.nickname === "Biorad" || user.nickname === "BIO-RAD" || user.nickname === "BIORAD") &&
                        <Box p={1} sx={{ display: 'flex', alignItems: 'center' }}>
                            <TextField size="small" placeholder='Company' onKeyDown={searchFilter} value={customer} onChange={(event) => setCustomer(event.target.value)} inputProps={{ style: { height: "12px", fontSize: "14px", width: "21.6vw", padding: "10px 14px 8px 14px" } }} />
                            {/* <label for="validationError" class="form-label text-danger">{getValidation[0].species}</label> */}
                        </Box>
                    }
                    <Box p={1} sx={{ display: 'flex', alignItems: 'center' }}>
                        {/* <DatePicker id="date" value={sDate} onChange={(event) => setSDate(event.target.value)}></DatePicker> */}
                        {/* <Typography fontWeight={500} fontSize={14} color="text.secondary" style={{ marginRight: 50 }}>Date</Typography> */}
                        <TextField size="small" type="date" onKeyDown={searchFilter} value={sDate} placeholder='Start Date' onChange={(event) => setSDate(event.target.value)} sx={{ width: '100%' }} style={{ marginRight: 14 }} inputProps={{ style: { height: "13px", fontSize: "14px" } }} />
                        {/* <Typography fontWeight={500} fontSize={14} color="text.secondary" style={{ marginRight: 5 }}>-</Typography> */}
                        <TextField size="small" type="date" onKeyDown={searchFilter} placeholder='End Date' value={eDate} onChange={(event) => setEDate(event.target.value)} sx={{ width: '100%' }} style={{ marginLeft: 3 }} inputProps={{ style: { height: "13px", fontSize: "14px" } }} />
                    </Box>

                    <Box p={1} sx={{ display: 'flex', alignItems: 'center' }}>
                        {/* <Typography fontWeight={500} fontSize={14} color="text.secondary" style={{ marginRight: 6 }}> Status</Typography> */}
                        <Select fontWeight={500} placeholder="Status" fontSize={12} size="small" value={status} onChange={(event) => setStatus(event.target.value)} sx={{ width: 153, height: 33, }} >
                            <MenuItem value={0}>--Select Status--</MenuItem>
                            <MenuItem value={2}>Saved</MenuItem>
                            <MenuItem value={3}>Submitted</MenuItem>
                            {/* <MenuItem value={4}>Acknowledged</MenuItem> */}
                            <MenuItem value={5}>Responded</MenuItem>
                            <MenuItem value={6}>Closed</MenuItem>
                        </Select>
                    </Box>
                    <Box p={1} sx={{ alignContent: "center", marginLeft: 5, marginRight: 0.4 }}>

                        <Button sx={{ width: 20, color: '#fff', bgcolor: '#2962ff' }} onClick={searchFilter} startIcon={<SearchIcon sx={{ marginLeft: 1 }} />} />
                        <Button variant="contained" color="primary" sx={{ width: 20, marginLeft: 1, color: '#fff', bgcolor: '#2962ff' }} onClick={() => handleClearFilter()} >Clear</Button>
                        {/* <Button size="medium" variant="contained" color="#fff" sx={{ width: 100 }}  >Clear</Button> */}
                        {/* <Button 
                                        size="medium" 
                                        variant="contained" 
                                        // disabled={isNew ? true : false}
                                        color="primary" 
                                        sx={{ width: 20,marginLeft:1 }} 
                                        onClick={() => navigate('/dashboard', { state: { isBack:true} })}                                    >
                                        Clear
                                    </Button> */}
                    </Box>

                </Box>
                <Box>
                    {/* <Button size="medium" variant="contained" color="#fff" sx={{ width: 100 }}  >Clear</Button> */}
                    {/* <Button 
                                        size="medium" 
                                        variant="contained" 
                                        // disabled={isNew ? true : false}
                                        color="success" 
                                        sx={{ width: 100 }} 
                                        onClick={data => navigate('/dashboard')}                                    >
                                        Clear
                                    </Button> */}

                </Box>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'row', border: 0.5, borderColor: "text.secondary" }} />
            <Box p={1} sx={{ display: 'flex', flexDirection: 'column' }}>
                <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                    <TableContainer sx={{ height: '56vh' }} >
                        <Table stickyHeader={true} sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                            <TableHead>
                                <TableRow style={{ textAlign: "center" }}>
                                    <TableCell align="left" ><b>Description</b></TableCell>
                                    <TableCell align="left" ><b>Date</b></TableCell>
                                    <TableCell align="left" style={{ textAlign: "left" }}><b>Species</b></TableCell>
                                    <TableCell align="left" ><b>No. of Cells</b></TableCell>
                                    <TableCell align="left" ><b>No. of Samples</b></TableCell>
                                    <TableCell align="left" ><b>Sample Name</b></TableCell>
                                    <TableCell align="left" ><b>Status</b></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody sx={{ paddingBottom: '10px' }} style={{ textAlign: "center" }}>
                                {(rowsPerPage > 0
                                    ? filterData && filterData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    : filterData
                                ).map(row => (

                                    <TableRow key={row.experiment_id}>
                                        <TableCell align="left">
                                            {
                                                user.nickname !== "Bio-Rad" && (row.experiment_status === "Saved" || row.experiment_status === "Responded") &&
                                                <a href='#' onClick={data => navigate('/home', { state: { data: row, isView: false } })}><p className='text-short'>{row.description} </p></a>
                                            }
                                            {
                                                user.nickname !== "Bio-Rad" && (row.experiment_status === "Submitted" || row.experiment_status === "Acknowledged" || row.experiment_status === "Closed") &&
                                                <a href='#' onClick={data => navigate('/home', { state: { data: row, isView: false } })}><p className='text-short'>{row.description} </p></a>
                                            }

                                            {
                                                user.nickname === "Bio-Rad" && (row.experiment_status === "Submitted" || row.experiment_status === "Acknowledged") &&
                                                <a href='#' onClick={data => navigate('/home', { state: { data: row, isView: false } })}><p className='text-short'>{row.description} </p></a>
                                            }
                                            {
                                                user.nickname === "Bio-Rad" && (row.experiment_status === "Responded") &&
                                                <a href='#' onClick={data => navigate('/home', { state: { data: row, isView: false } })}><p className='text-short'>{row.description}</p></a>
                                            }
                                            {
                                                user.nickname === "Bio-Rad" && (row.experiment_status === "Closed") &&
                                                <a href='#' onClick={data => navigate('/home', { state: { data: row, isView: true } })}><p className='text-short'>{row.description}</p></a>
                                            }

                                        </TableCell>
                                        <TableCell align="left" style={{ textAlign: "left" }}>{format(new Date(row.experiment_date), 'dd-MMM-yy')}</TableCell>
                                        <TableCell align="left" style={{ textAlign: "left" }}>{row.species}</TableCell>
                                        <TableCell align="center">{row.no_of_cells}</TableCell>
                                        <TableCell align="center">{row.no_of_samples}</TableCell>
                                        <TableCell align="left">{row.sample_name}</TableCell>
                                        <TableCell align="left">{row.experiment_status}</TableCell>
                                        {/* <TableCell ><Attachement experiment_ID={row.experiment_id} />
                                                <Historybutton event={row}></Historybutton>
                                                <Button sx={{ minWidth: '25px !important' }} disabled={user.nickname === "Bio-Rad" && row.experiment_status === "Saved" ? true : false} onClick={data => navigate('/home', { state: row })} startIcon={<EditIcon />} />
                                            </TableCell> */}
                                    </TableRow>
                                ))
                                }

                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[10, 25, 100]}
                        colSpan={3}
                        component="div"
                        count={filterData.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Paper>

            </Box>
        </div>
    )
}



export default DashboardCustomer;




